import { API_ENDPOINTS, makeAuthenticatedApiRequest, type ApiResult } from './apiConfig';
import { validateAccessToken } from './validators';

// Types based on API spec
export interface ChatRequest {
  message: string;
  conversationId?: string;
}

export interface ChatResponse {
  answer: string;
  conversationId: string;
  supportingData?: Record<string, any>;
  toolCalls?: Array<{
    tool: string;
    arguments: any;
  }>;
  metadata?: {
    messageCount: number;
    estimatedTokens: number;
    hasSummary: boolean;
  };
}

/**
 * Send a message to the financial assistant
 */
export async function sendChatMessage(
  message: string,
  conversationId: string | undefined,
  accessToken: string
): Promise<ApiResult<ChatResponse>> {
  validateAccessToken(accessToken);

  if (!message || message.trim().length === 0) {
    throw new Error('Message cannot be empty');
  }

  if (message.length > 2000) {
    throw new Error('Message exceeds maximum length of 2000 characters');
  }

  const requestBody: ChatRequest = {
    message: message.trim(),
    ...(conversationId && { conversationId })
  };

  return makeAuthenticatedApiRequest<ChatResponse>(
    API_ENDPOINTS.FINANCIAL_ASSISTANT.CHAT,
    requestBody,
    accessToken
  );
}
